export default __webpack_public_path__ + "static/media/card-calendar.c3c22ed0.svg";